<div class="pagination-wrapper" [ngClass]="{'expand':expandOnDesktopRes}">
  <div class="normal-pagination" *ngIf="paging">
    <a [href]="createLink(paging, paging.currentPage - 1)">
      <i class="ai ai-back" [ngClass]="{'disabled':!isCurrentPageMoreThanFirst}" (click)="changeForPreviewPage()"></i>
    </a>
    <input class="input no-label" #inputValue [(ngModel)]="paging.currentPage" (blur)="changeByBlur()" (keyup)="changeByEnter($event)">
    <p>
      {{ 'pagination.from' |translate }}
      <span class="page-count">{{paging.pageCount}}</span>
    </p>
    <a [href]="createLink(paging, paging.currentPage + 1)">
      <i class="ai ai-next" [ngClass]="{'disabled':!isCurrentPageLessThenLast}" (click)="changeForNextPage()"></i>
    </a>
  </div>
  <div class="expanded-pagination">
    <ng-container *ngIf="paging">
      <!-- Poprzednia strona -->
      <div class="page-item previous-page" (click)="changeForPreviewPage()">
        <a [href]="createLink(paging, paging.currentPage - 1)">
          <i class="ai ai-back" [ngClass]="{'disabled':!isCurrentPageMoreThanFirst}"></i>
        </a>
      </div>
      <!-- Pierwsza strona -->
      <div class="page-item number" [ngClass]="{'active': paging.currentPage===1}" (click)="changePage(1)">
        <a class="page-link" [href]="createLink(paging, 1)">
          1
        </a>
      </div>
      <div *ngIf="paging.currentPage > 3" class="page-item more">
        <span class="page-link">...</span>
      </div>
      <!-- Kolejne strony -->
      <div class="page-item number" *ngIf="paging.currentPage>2" (click)="changePage(paging.currentPage-1)">
        <a class="page-link" [href]="createLink(paging, paging.currentPage - 1)">
          {{ paging.currentPage - 1 }}
        </a>
      </div>
      <div class="page-item number active" *ngIf="paging.currentPage>1 && paging.currentPage<paging.pageCount"
           (click)="changePage(paging.currentPage)">
        <a class="page-link" [href]="createLink(paging, paging.currentPage)">
          {{ paging.currentPage}}
        </a>
      </div>
      <div class="page-item number" *ngIf="paging.currentPage+1<paging.pageCount" (click)="changePage(paging.currentPage+1)">
        <a class="page-link" [href]="createLink(paging, paging.currentPage + 1)">
          {{ paging.currentPage + 1 }}
        </a>
      </div>
      <!-- Ostatnia strona -->
      <div *ngIf="paging.currentPage+2<paging.pageCount" class="page-item more">
        <span class="page-link">...</span>
      </div>
      <div class="page-item number" [ngClass]="{'active': paging.currentPage===paging.pageCount}" (click)="changePage(paging.pageCount)">
        <a class="page-link" [href]="createLink(paging, paging.pageCount)">
          {{ paging.pageCount }}
        </a>
      </div>
      <!-- Następna strona -->
      <div class="page-item next-page" (click)="changeForNextPage()">
        <a [href]="createLink(paging, paging.currentPage + 1)">
          <i class="ai ai-next" [ngClass]="{'disabled':!isCurrentPageLessThenLast}"></i>
        </a>
      </div>
    </ng-container>

  </div>
</div>
